var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"tabCommonArea"},[_c('MoneyUnitSelect')],1),_c('el-row',[_c('Tabs',{attrs:{"tabs":_vm.tabs},on:{"change":_vm.setTabIndex}})],1),_c(_vm.tabComponent(),{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }